export default __webpack_public_path__ + "static/media/bgTop.c76011d4.jpg";